function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import mixpanel from 'mixpanel-browser';
import featureEnabled from 'shared/helper/feature';
import hasStatisticsConsent from 'rubriq/helpers/cookieConsent';
import { NAVBAR_TRACKING } from '../constants';
var initialized = false;
var MIXPANEL_TOKEN = null;
export var initMixpanel = function initMixpanel(token) {
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!hasStatisticsConsent()) return;
  if (initialized) return;
  if (!token) return;
  MIXPANEL_TOKEN = token;
  // comment to check the auto PR
  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: true,
    record_sessions_percent: 100,
    debug: process.env.NODE_ENV !== 'production',
    track_pageview: true,
    persistence: 'localStorage',
    record_heatmap_data: true
  });
  if (hasStatisticsConsent()) {
    mixpanel.opt_in_tracking();
  } else {
    mixpanel.opt_out_tracking();
  }
  mixpanel.register({
    app: NAVBAR_TRACKING.Rubriq_B2C,
    environment: process.env.NODE_ENV
  });
  initialized = true;
};
export var trackEvent = function trackEvent(eventName) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!initialized) return;
  mixpanel.track(eventName, properties);
};
export var trackNavbarEventMixpanel = function trackNavbarEventMixpanel(label, section) {
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!initialized) return;
  mixpanel.track('Navbar Clicked', _objectSpread({
    label: label,
    section: section,
    page: window.location.pathname,
    device: navigator.userAgent
  }, extra));
};
export var identifyUser = function identifyUser(userId) {
  var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!featureEnabled('rubriq_mixpanel')) return;
  if (!initialized) return;
  mixpanel.identify(userId);
  mixpanel.people.set(traits);
};
export var resetMixpanel = function resetMixpanel() {
  try {
    if (!featureEnabled('rubriq_mixpanel')) return;
    if (!mixpanel || typeof mixpanel.reset !== 'function') return;
    mixpanel.reset();
  } catch (error) {
    console.error('Error during mixpanel reset:', error);
  }
};